import createCrudVuexModule from "@/store/crud";

export const managementTaskCategory = createCrudVuexModule({
  namespaced: true,
  path: "/management/library/task-category",
});
export const workspaceTaskCategory = createCrudVuexModule({
  namespaced: true,
  path: "/workspace/library/task-category",
});

export const taskCategory = createCrudVuexModule({
  namespaced: true,
  path: "/library/task-category",
});
